<div *ngIf="(managementService.taskDetailsObservable$ | async) as drawerTask">
    <ng-container *ngIf="!isDialogTarget">
    <ng-template #taskDetailsContent>
        <div class="task-details-container">
        <div class="task-header">
            <div class="title-section">
                    <div class="title-row">
                        <div class="title" [attr.id]="isDialogMode ? 'task-details-dialog-title' : null">
                            {{taskDetail?.title || drawerTask.title}}
                        </div>
                        <div class="task-actions">
                            <button type="button" class="task-overflow-button"
                                [matMenuTriggerFor]="taskActionsMenu" aria-label="Task actions">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <button *ngIf="isDialogMode" type="button" class="task-close-button"
                                aria-label="Close task details" (click)="closeTaskDetailsView()">
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>
                        <mat-menu #taskActionsMenu="matMenu" class="task-details-actions-menu" xPosition="before">
                            <button mat-menu-item type="button" (click)="enableEdit()" *ngIf="!isEditing">
                                <mat-icon>edit</mat-icon>
                                <span>Edit</span>
                            </button>
                            <button mat-menu-item type="button" (click)="deleteTask()" [disabled]="submitted">
                                <mat-icon>delete</mat-icon>
                                <span>Delete</span>
                            </button>
                        </mat-menu>
                    </div>
                <div class="breadcrumb-row">
                    <span>Tasks</span>
                    <span>/</span>
                    <span>{{taskDetail?.status || drawerTask.status}}</span>
                    <span>/</span>
                    <strong>{{taskDetail?.title || drawerTask.title}}</strong>
                </div>
            </div>
        </div>
        <div *ngIf="taskDetail || isLoading" class="subtask-container">
            <ng-container *ngIf="!isLoading; else subtaskLoader">
                <form [formGroup]="editTaskForm" class="task-edit-form" *ngIf="isEditing; else taskReadView">
                    <div class="form-section">
                        <div class="form-section-title">Basics</div>
                        <div class="form-field">
                            <div class="lable">Title *</div>
                            <input type="text" class="title-field"
                                [ngClass]="{'has-error' : editTaskTitle.touched && !editTaskTitle.valid}"
                                autocomplete="off" formControlName="taskTitle">
                        </div>
                        <div class="form-field">
                            <div class="lable">Description</div>
                            <textarea class="description-field" matInput autocomplete="off"
                                formControlName="taskDesc"></textarea>
                        </div>
                        <div class="form-field checklist-field">
                            <div class="lable">Add Checklist</div>
                            <div class="checklist-list">
                                <div class="checklist-read-row" *ngFor="let item of detailChecklistItems; index as i; trackBy: trackByChecklistItem">
                                    <button type="button" class="checklist-read-checkbox"
                                        [class.checked]="isChecklistItemComplete(item)"
                                        (click)="toggleDraftChecklistItem(i)">
                                        <mat-icon *ngIf="isChecklistItemComplete(item)">check</mat-icon>
                                    </button>
                                    <input class="checklist-read-input"
                                        [class.completed]="isChecklistItemComplete(item)"
                                        [value]="checklistItemValue(item)"
                                        placeholder="Enter a task"
                                        (input)="updateDraftChecklistTitle(i, $event)">
                                    <button type="button" class="checklist-remove-btn" (click)="removeDraftChecklistItem(i)">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                </div>
                            </div>
                            <button type="button" class="inline-add-btn" (click)="addDraftChecklistItem()">+ Add item</button>
                        </div>
                    </div>
                    <div class="form-section">
                        <div class="form-section-title">Planning</div>
                        <div class="task-edit-grid">
                            <div class="form-field">
                                <div class="lable">Status</div>
                                <mat-form-field appearance="fill" class="topic-select">
                                    <mat-select formControlName="taskStatus" panelClass="create-task-select-panel">
                                        <mat-option [value]="'To do'">To do</mat-option>
                                        <mat-option [value]="'In progress'">In progress</mat-option>
                                        <mat-option [value]="'Blocked'">Blocked</mat-option>
                                        <mat-option [value]="'In review'">In review</mat-option>
                                        <mat-option [value]="'Completed'">Completed</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="form-field">
                                <div class="lable">Priority</div>
                                <mat-form-field appearance="fill" class="topic-select">
                                    <mat-select formControlName="taskPriority" panelClass="create-task-select-panel">
                                        <mat-option [value]="'HIGH'">High</mat-option>
                                        <mat-option [value]="'MEDIUM'">Medium</mat-option>
                                        <mat-option [value]="'LOW'">Low</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="form-field">
                                <div class="lable">Due date</div>
                                <input type="date" class="title-field" autocomplete="off" formControlName="taskDueAt">
                            </div>
                            <div class="form-field">
                                <div class="lable">Assignees</div>
                                <mat-form-field appearance="fill" class="topic-select">
                                    <mat-select formControlName="taskAssigneeIds" multiple panelClass="create-task-select-panel">
                                        <mat-select-trigger>
                                            <span class="assignee-select-summary" *ngIf="selectedEditAssignees().length === 1">
                                                {{selectedEditAssignees()[0] | memberFullName}}
                                            </span>
                                            <span class="assignee-select-summary" *ngIf="selectedEditAssignees().length > 1">
                                                {{selectedEditAssignees().length}} assignees
                                            </span>
                                        </mat-select-trigger>
                                        <mat-option class="topic-item suggest" *ngFor="let person of assigneeList"
                                            [value]="person.id">{{person | memberFullName}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </form>

                <ng-template #taskReadView>
                <app-portal-detail-section
                    *ngIf="taskDetail"
                    title="Task Overview"
                    sectionClass="task-overview-section"
                    [open]="isSectionOpen('overview')"
                    (toggle)="toggleSection('overview')">
                        <div class="task-meta-list">
                            <div class="task-meta-line">
                                <span>Status</span>
                                <strong class="status-value" [ngClass]="statusClass(taskDetail.status)">
                                    <span></span>{{taskDetail.status}}
                                </strong>
                            </div>
                            <div class="task-meta-line">
                                <span>Priority</span>
                                <strong class="priority-chip" [ngClass]="priorityClass(taskDetail.priority)">
                                    <span></span>{{priorityLabel(taskDetail.priority)}}
                                </strong>
                            </div>
                            <div class="task-meta-line">
                                <span>Due Date</span>
                                <strong>
                                    <mat-icon>event</mat-icon>
                                    {{taskDetail.dueAt ? formatDate(taskDetail.dueAt) : (taskDetail.dueLabel || 'No due date')}}
                                </strong>
                            </div>
                            <div class="task-meta-line">
                                <span>Assignees</span>
                                <strong class="meta-assignees">
                                    <span class="meta-avatar-stack" *ngIf="detailVisibleAssignees.length; else noDetailAssignees">
                                        <span class="meta-avatar" *ngFor="let assignee of detailVisibleAssignees; trackBy: trackByMemberId"
                                            [matTooltip]="assignee | memberFullName" matTooltipPosition="above">
                                            <img *ngIf="assignee.avatarUrl" [appAvatarImage]="assignee.avatarUrl" [src]="assignee.avatarUrl" [alt]="assignee | memberFullName" />
                                            <span *ngIf="!assignee.avatarUrl" [style.background]="avatarColorFor(assignee.id)">
                                                {{assignee | memberInitials}}
                                            </span>
                                        </span>
                                    </span>
                                    <ng-template #noDetailAssignees>Unassigned</ng-template>
                                    <button type="button" class="meta-add-btn" (click)="enableEdit()">+ Add</button>
                                </strong>
                            </div>
                            <div class="task-meta-line" *ngIf="detailCreatedBy as creator">
                                <span>Created By</span>
                                <strong>
                                    <span class="meta-avatar single">
                                        <img *ngIf="creator.avatarUrl" [appAvatarImage]="creator.avatarUrl" [src]="creator.avatarUrl" [alt]="creator | memberFullName" />
                                        <span *ngIf="!creator.avatarUrl" [style.background]="avatarColorFor(creator.id)">
                                            {{creator | memberInitials}}
                                        </span>
                                    </span>
                                    {{creator | memberFullName}}
                                </strong>
                            </div>
                            <div class="task-meta-line">
                                <span>Fund</span>
                                <strong>
                                    <span class="fund-dot"></span>
                                    {{taskDetail.company?.name || 'General'}}
                                </strong>
                            </div>
                            <div class="task-meta-line" *ngIf="isClickUpTask()">
                                <span>Task Source</span>
                                <strong>
                                    <img class="detail-clickup-logo" src="assets/images/clickuplogo.png" alt="ClickUp" />
                                    ClickUp
                                </strong>
                            </div>
                        </div>
                </app-portal-detail-section>

                <app-portal-detail-section
                    title="Description"
                    [open]="isSectionOpen('description')"
                    (toggle)="toggleSection('description')">
                        <div class="description-box" *ngIf="taskDetail?.description; else noDescription">
                            <div [innerHTML]="convertTextToLinks(taskDetail?.description || '')"></div>
                        </div>
                </app-portal-detail-section>

                <app-portal-detail-section
                    *ngIf="taskDetail"
                    title="Comments"
                    sectionClass="comments-section"
                    [open]="isSectionOpen('comments')"
                    (toggle)="toggleSection('comments')">
                        <span portalDetailSectionMeta class="section-header-meta count-meta" *ngIf="taskDetail.commentsCount">
                            <mat-icon>chat_bubble_outline</mat-icon>
                            <span>{{taskDetail.commentsCount}}</span>
                        </span>
                        <div class="comments-list" *ngIf="taskDetail.comments.length; else noComments">
                            <div class="comment-item" *ngFor="let comment of taskDetail.comments; trackBy: trackByCommentId">
                                <button class="comment-avatar-btn" type="button"
                                    [disabled]="!comment.author"
                                    (click)="openMemberProfile(comment.author, $event)"
                                    [attr.aria-label]="comment.author ? 'Open profile of ' + commentAuthorName(comment) : 'Comment author'">
                                    <img *ngIf="comment.author?.avatarUrl" class="comment-avatar-img"
                                        [appAvatarImage]="comment.author?.avatarUrl"
                                        [src]="comment.author?.avatarUrl"
                                        [alt]="commentAuthorName(comment)" />
                                    <span *ngIf="!comment.author?.avatarUrl" class="comment-avatar-fallback"
                                        [style.background]="avatarColorFor(comment.author?.id || comment.id)">
                                        {{comment.author ? (comment.author | memberInitials) : 'U'}}
                                    </span>
                                </button>
                                <div class="comment-copy">
                                    <div class="comment-meta">
                                        <button class="comment-author" type="button"
                                            *ngIf="comment.author; else commentAuthorText"
                                            (click)="openMemberProfile(comment.author, $event)">
                                            {{commentAuthorShort(comment)}}
                                        </button>
                                        <ng-template #commentAuthorText>
                                            <strong class="comment-author-text">Unknown</strong>
                                        </ng-template>
                                        <span>{{relativeTime(comment.createdAt)}}</span>
                                    </div>
                                    <div class="comment-body">{{comment.body}}</div>
                                </div>
                            </div>
                        </div>
                        <ng-template #noComments>
                            <div class="description-box empty">No comments yet</div>
                        </ng-template>
                        <button class="leave-comment-btn" type="button" *ngIf="!showCommentForm"
                            (click)="openCommentForm()">
                            <mat-icon>chat_bubble_outline</mat-icon>
                            <span>Leave Comments</span>
                        </button>
                        <form class="comment-form" *ngIf="showCommentForm" [formGroup]="commentForm" (ngSubmit)="submitComment()">
                            <textarea class="comment-field" rows="3" formControlName="commentText"
                                placeholder="Add an internal comment"></textarea>
                            <div class="comment-actions">
                                <span>{{(commentTextControl.value || '').length}}/4000</span>
                                <button type="submit" [disabled]="!commentForm.valid || isSubmittingComment">
                                    <mat-icon *ngIf="isSubmittingComment">sync</mat-icon>
                                    <span>{{isSubmittingComment ? 'Posting' : 'Post comment'}}</span>
                                </button>
                            </div>
                        </form>
                </app-portal-detail-section>

                <app-portal-detail-section
                    *ngIf="taskDetail"
                    title="Checklist {{detailChecklistCompleted}}/{{detailChecklistItems.length}}"
                    sectionClass="checklist-section"
                    [open]="isSectionOpen('checklist')"
                    (toggle)="toggleSection('checklist')">
                        <span portalDetailSectionMeta class="section-header-meta checklist-meta">
                            <span>{{detailChecklistCompleted}}/{{detailChecklistItems.length}} completed</span>
                            <span class="checklist-progress-track">
                                <span [style.width.%]="detailChecklistProgress"></span>
                            </span>
                        </span>
                        <div class="checklist-list">
                            <div class="checklist-read-row" *ngFor="let item of detailChecklistItems; index as i; trackBy: trackByChecklistItem">
                                <button type="button" class="checklist-read-checkbox"
                                    [class.checked]="isChecklistItemComplete(item)"
                                    (click)="toggleDraftChecklistItem(i)">
                                    <mat-icon *ngIf="isChecklistItemComplete(item)">check</mat-icon>
                                </button>
                                <input class="checklist-read-input"
                                    [class.completed]="isChecklistItemComplete(item)"
                                    [value]="checklistItemValue(item)"
                                    placeholder="Checklist item"
                                    (input)="updateDraftChecklistTitle(i, $event)">
                                <button type="button" class="checklist-remove-btn" (click)="removeDraftChecklistItem(i)">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </div>
                        </div>
                        <button type="button" class="inline-add-btn" (click)="addDraftChecklistItem()">+ Add item</button>
                </app-portal-detail-section>

                <ng-container [ngTemplateOutlet]="documentsBlock"></ng-container>

                <app-portal-detail-section
                    *ngIf="isClickUpTask()"
                    title="ClickUp Data"
                    sectionClass="clickup-metadata-section"
                    [open]="isSectionOpen('clickup')"
                    (toggle)="toggleSection('clickup')">
                        <span portalDetailSectionMeta class="section-header-meta timestamp-meta" *ngIf="taskDetail?.clickUp?.updatedAt">
                            {{relativeTime(taskDetail?.clickUp?.updatedAt || '')}}
                        </span>
                        <div class="clickup-metadata-grid">
                            <div class="clickup-metadata-item">
                                <div class="task-meta-label">Sync Status</div>
                                <div class="clickup-status-row">
                                    <span class="clickup-status-chip"
                                        [class.pending]="taskDetail?.clickUp?.pending"
                                        [class.error]="clickUpSyncError()">
                                        {{clickUpStatusLabel()}}
                                    </span>
                                    <span class="clickup-pending" *ngIf="taskDetail?.clickUp?.pending">Pending external create</span>
                                </div>
                            </div>
                            <div class="clickup-metadata-item" *ngIf="clickUpTaskId()">
                                <div class="task-meta-label">ClickUp Task ID</div>
                                <a class="task-meta-value clickup-link" *ngIf="clickUpUrl(); else clickUpTaskIdOnly"
                                    [href]="clickUpUrl()" target="_blank" rel="noopener noreferrer">
                                    {{clickUpTaskId()}}
                                </a>
                                <ng-template #clickUpTaskIdOnly>
                                    <div class="task-meta-value">{{clickUpTaskId()}}</div>
                                </ng-template>
                            </div>
                            <div class="clickup-metadata-item" *ngIf="taskDetail?.clickUp?.sourceUpdatedAt">
                                <div class="task-meta-label">ClickUp Updated</div>
                                <div class="task-meta-value">
                                    <mat-icon>event</mat-icon>
                                    {{formatDateTime(taskDetail?.clickUp?.sourceUpdatedAt || '')}}
                                </div>
                            </div>
                            <div class="clickup-metadata-item" *ngIf="taskDetail?.clickUp?.updatedAt">
                                <div class="task-meta-label">SPIKE Sync Updated</div>
                                <div class="task-meta-value">
                                    <mat-icon>event</mat-icon>
                                    {{formatDateTime(taskDetail?.clickUp?.updatedAt || '')}}
                                </div>
                            </div>
                        </div>
                        <div class="clickup-sync-error" *ngIf="clickUpSyncError()">
                            <mat-icon>error_outline</mat-icon>
                            <span>{{clickUpSyncError()}}</span>
                        </div>
                        <button type="button" class="clickup-refresh-link"
                            *ngIf="canRefreshFromClickUp()"
                            [disabled]="isSyncingClickUp"
                            (click)="refreshFromClickUp()">
                            <mat-icon [class.spin]="isSyncingClickUp">sync</mat-icon>
                            Refresh
                        </button>
                </app-portal-detail-section>

                <app-portal-detail-section
                    *ngIf="detailActivityItems.length"
                    title="Activity"
                    sectionClass="activity-section"
                    [open]="isSectionOpen('activity')"
                    (toggle)="toggleSection('activity')">
                        <span portalDetailSectionMeta class="section-header-meta timestamp-meta" *ngIf="latestActivityRelativeTime()">
                            {{latestActivityRelativeTime()}}
                        </span>
                    <div class="activity-list">
                        <div class="activity-item" *ngFor="let item of detailActivityItems; trackBy: trackByActivityItem">
                            <button class="activity-avatar-btn" type="button"
                                [disabled]="!item.user"
                                (click)="openMemberProfile(item.user, $event)"
                                [attr.aria-label]="item.actor ? 'Open profile of ' + item.actor : 'Activity actor'">
                                <img *ngIf="item.user?.avatarUrl" class="activity-avatar-img"
                                    [appAvatarImage]="item.user?.avatarUrl"
                                    [src]="item.user?.avatarUrl"
                                    [alt]="item.actor" />
                                <span *ngIf="!item.user?.avatarUrl" class="activity-avatar-fallback"
                                    [style.background]="activityAvatarColor(item.event)">
                                    {{activityInitials(item.event)}}
                                </span>
                            </button>
                            <div class="activity-copy">
                                <div class="activity-line">
                                    <button class="activity-actor" type="button"
                                        *ngIf="item.user; else activityActorText"
                                        (click)="openMemberProfile(item.user, $event)">
                                        {{item.actorShort || item.actor || 'Unknown user'}}
                                    </button>
                                    <ng-template #activityActorText>
                                        <strong class="activity-actor-text">{{item.actorShort || item.actor || 'System'}}</strong>
                                    </ng-template>
                                    <span class="activity-action">{{item.actionLabel}}</span>
                                </div>
                                <a class="activity-file-card" *ngIf="item.file"
                                    [href]="item.file.currentVersion?.downloadUrl || null"
                                    [class.disabled]="!item.file.currentVersion?.downloadUrl"
                                    target="_blank"
                                    rel="noopener">
                                    <span class="activity-file-icon">
                                        <mat-icon>picture_as_pdf</mat-icon>
                                        <small>PDF</small>
                                    </span>
                                    <span class="activity-file-copy">
                                        <strong>{{documentName(item.file)}}</strong>
                                        <span>{{documentMeta(item.file) || 'Attached file'}}</span>
                                    </span>
                                    <mat-icon class="activity-download-icon">download</mat-icon>
                                </a>
                                <div class="activity-checklist-card" *ngIf="item.checklistLabel">
                                    <mat-icon>check_box_outline_blank</mat-icon>
                                    <span>{{item.checklistLabel}}</span>
                                </div>
                                <div class="activity-change-list" *ngIf="item.changeRows.length">
                                    <div class="activity-change-row"
                                        *ngFor="let changeRow of item.changeRows; trackBy: trackByActivityChangeRow">
                                        <span>{{changeRow.label}}</span>
                                        <strong *ngIf="changeRow.value">{{changeRow.value}}</strong>
                                        <strong class="change-diff" *ngIf="!changeRow.value">
                                            <span *ngIf="changeRow.from">{{changeRow.from}}</span>
                                            <mat-icon *ngIf="changeRow.from && changeRow.to">arrow_forward</mat-icon>
                                            <span *ngIf="changeRow.to">{{changeRow.to}}</span>
                                        </strong>
                                    </div>
                                </div>
                                <div class="activity-date">
                                    <span>{{item.dateLabel}}</span>
                                    <span>{{item.timeLabel}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </app-portal-detail-section>

                <app-portal-detail-section
                    *ngIf="taskDetail"
                    title="Notification"
                    sectionClass="notification-section"
                    [open]="isSectionOpen('notification')"
                    (toggle)="toggleSection('notification')">
                    <section class="task-detail-footer">
                        <div class="task-footer-notifications">
                            <button type="button" class="notification-toggle"
                                [attr.aria-pressed]="footerNotifyInApp"
                                (click)="setFooterNotifyInApp(!footerNotifyInApp)">
                                <span>In-app notification</span>
                                <span class="notification-switch" [class.is-on]="footerNotifyInApp" aria-hidden="true"></span>
                            </button>
                            <button type="button" class="notification-toggle"
                                [attr.aria-pressed]="footerNotifyEmail"
                                (click)="setFooterNotifyEmail(!footerNotifyEmail)">
                                <span>Email notification</span>
                                <span class="notification-switch" [class.is-on]="footerNotifyEmail" aria-hidden="true"></span>
                            </button>
                        </div>
                    </section>
                </app-portal-detail-section>
                </ng-template>
            </ng-container>
        </div>
        <div class="task-footer-actions portal-detail-sticky-actions" *ngIf="taskDetail && isEditing">
            <button class="cancel" type="button" (click)="cancelEdit()">Cancel</button>
            <button class="submit" type="button" [disabled]="!editTaskForm.valid || submitted"
                (click)="saveTask()">Save changes</button>
        </div>
        <div class="task-footer-actions portal-detail-sticky-actions" *ngIf="taskDetail && !isEditing">
            <button class="cancel" type="button" (click)="cancelTaskFooterChanges()">
                {{ isDialogMode && !hasTaskFooterChanges() ? 'Close' : 'Cancel' }}
            </button>
            <button class="submit" type="button"
                [disabled]="!hasTaskFooterChanges() || submitted"
                (click)="saveTaskFooterChanges()">Save</button>
        </div>
        </div>
    </ng-template>
        <ng-container *ngIf="!isSuggest">
        <ng-container *ngIf="isDialogMode; else taskDetailsDrawer">
            <div class="task-details-dialog-shell" role="dialog" aria-modal="true"
                aria-labelledby="task-details-dialog-title">
                <div class="task-details-dialog-card">
                    <ng-container *ngTemplateOutlet="taskDetailsContent"></ng-container>
                </div>
            </div>
        </ng-container>
        <ng-template #taskDetailsDrawer>
            <app-portal-detail-drawer
                variant="task"
                drawerTitle="Task Details"
                [resetScrollKey]="drawerTask.taskId || taskId"
                (backClick)="managementService.closeDrawer()"
                (closeClick)="managementService.closeDrawer()">
                <ng-container *ngTemplateOutlet="taskDetailsContent"></ng-container>
            </app-portal-detail-drawer>
        </ng-template>
    </ng-container>
    <ng-container *ngIf="isSuggest">
        <ng-container *ngIf="isDialogMode; else suggestTaskDrawer">
            <div class="create-task-dialog-shell" role="dialog" aria-modal="true" aria-labelledby="create-task-dialog-title">
                <ng-container *ngTemplateOutlet="suggestTaskContent"></ng-container>
            </div>
        </ng-container>
        <ng-template #suggestTaskDrawer>
            <app-portal-detail-drawer
                variant="task"
                drawerTitle="Create task"
                [resetScrollKey]="'create-task'"
                (backClick)="closeCreateDialog()"
                (closeClick)="closeCreateDialog()">
                <ng-container *ngTemplateOutlet="suggestTaskContent"></ng-container>
            </app-portal-detail-drawer>
        </ng-template>
    </ng-container>
    </ng-container>
</div>

<dialog *ngIf="pendingConfirmation" #taskConfirmDialog class="task-confirm-dialog"
    aria-labelledby="task-confirm-dialog-title" aria-describedby="task-confirm-dialog-copy"
    (cancel)="cancelConfirmation()">
    <div class="task-confirm-dialog-header">
        <span class="task-confirm-dialog-icon" aria-hidden="true">
            <mat-icon>delete_outline</mat-icon>
        </span>
        <button type="button" class="task-confirm-dialog-close" aria-label="Close confirmation"
            (click)="cancelConfirmation()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <h2 id="task-confirm-dialog-title">
        {{pendingConfirmation === 'delete-task' ? 'Delete this task?' : 'Remove this attachment?'}}
    </h2>
    <p id="task-confirm-dialog-copy">
        {{pendingConfirmation === 'delete-task'
            ? 'This action cannot be undone.'
            : 'The file will be removed from this task.'}}
    </p>
    <div class="task-confirm-dialog-actions">
        <button type="button" class="task-confirm-dialog-cancel" (click)="cancelConfirmation()">
            Cancel
        </button>
        <button type="button" class="task-confirm-dialog-confirm" [disabled]="submitted"
            (click)="confirmPendingAction()">
            {{pendingConfirmation === 'delete-task' ? 'Delete' : 'Remove'}}
        </button>
    </div>
</dialog>

<ng-template #suggestTaskContent>
    <div class="suggest-task-container" [class.suggest-task-container--dialog]="isDialogMode">
        <div class="suggest-task-header">
            <div class="heading" id="create-task-dialog-title">Create task</div>
            <button *ngIf="isDialogMode" type="button" class="create-task-close" aria-label="Close create task dialog"
                (click)="closeCreateDialog()">
                <mat-icon>close</mat-icon>
            </button>
            <div class="breadcrumb-row" *ngIf="!isDialogMode">
                <span>Tasks</span>
                <span>/</span>
                <strong>{{taskSource.value === 'clickup' ? 'ClickUp' : 'ACE'}}</strong>
            </div>
        </div>
        <form [formGroup]="suggestTaskForm" (ngSubmit)="submitTask()">
            <div class="suggest-task-form">
                <div class="form-section">
                    <div class="form-field">
                        <label class="lable" [attr.for]="isDialogMode ? 'task-create-title-dialog' : 'task-create-title-drawer'">
                            Title <span class="required-mark">*</span>
                        </label>
                        <input type="text" class="title-field"
                            [id]="isDialogMode ? 'task-create-title-dialog' : 'task-create-title-drawer'"
                            [attr.aria-invalid]="taskTitle.touched && taskTitle.invalid ? 'true' : null"
                            [attr.aria-describedby]="taskTitle.touched && taskTitle.invalid ? (isDialogMode ? 'task-create-title-error-dialog' : 'task-create-title-error-drawer') : null"
                            [ngClass]="{'has-error' : taskTitle.touched && !taskTitle.valid}" placeholder="Enter a title"
                            autocomplete="off" formControlName="taskTitle">
                        <div class="error-message" *ngIf="taskTitle.touched && taskTitle.invalid"
                            [id]="isDialogMode ? 'task-create-title-error-dialog' : 'task-create-title-error-drawer'">
                            {{taskTitle.hasError('required') ? 'Please enter a title.' : 'Title must be at least 2 characters.'}}
                        </div>
                    </div>
                    <div class="form-field">
                        <div class="lable">Description</div>
                        <textarea class="description-field" matInput placeholder="Enter a description"
                            autocomplete="off" formControlName="taskDesc"></textarea>
                    </div>
                    <div class="form-field checklist-field">
                        <div class="lable">Add Checklist</div>
                        <div class="checklist-create-list" formArrayName="taskChecklistItems">
                            <div class="checklist-create-row" [class.has-remove]="!!item.value"
                                *ngFor="let item of taskChecklistItems.controls; index as i">
                                <input type="checkbox" class="checklist-checkbox" aria-label="Checklist item completed">
                                <input type="text" class="title-field" [formControlName]="i" placeholder="Enter a task">
                                <button type="button" class="remove-checklist-item"
                                    aria-label="Remove checklist item" (click)="removeChecklistItem(i)">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </div>
                        </div>
                        <button type="button" class="inline-add-btn" (click)="addChecklistItem()">+ Add item</button>
                    </div>
                </div>
                <div class="form-section">
                    <div class="task-edit-grid">
                        <div class="form-field">
                            <div class="lable">Fund <span class="required-mark">*</span></div>
                            <mat-form-field appearance="fill" class="topic-select">
                                <mat-select placeholder="Select a fund" #fundSelect formControlName="taskFundId"
                                    panelClass="create-task-select-panel">
                                    <mat-option class="topic-item suggest" *ngFor="let fund of funds"
                                        [value]="fund.id">{{fund.name}}</mat-option>
                                </mat-select>
                                <img class="arrow-down" [ngClass]="{ 'open': fundSelect.panelOpen}"
                                    src="../../assets/images/arrow-down.svg" matSuffix alt="">
                            </mat-form-field>
                            <div class="error-message" *ngIf="taskFundId.touched && !taskFundId.valid">Please select a fund</div>
                        </div>
                        <div class="form-field">
                            <div class="lable">Priority <span class="required-mark">*</span></div>
                            <mat-form-field appearance="fill" class="topic-select"
                                [ngClass]="{'error' : taskPriority.touched && !taskPriority.valid}">
                                <mat-select placeholder="Choose Priority" #select formControlName="taskPriority"
                                    panelClass="create-task-select-panel">
                                    <mat-option class="topic-item suggest" [value]="'HIGH'">High</mat-option>
                                    <mat-option class="topic-item suggest" [value]="'MEDIUM'">Medium</mat-option>
                                    <mat-option class="topic-item suggest" [value]="'LOW'">Low</mat-option>
                                </mat-select>
                                <img class="arrow-down" [ngClass]="{ 'open': select.panelOpen}"
                                    src="../../assets/images/arrow-down.svg" matSuffix alt="">
                            </mat-form-field>
                            <div class="error-message" *ngIf="taskPriority.touched && !taskPriority.valid">Please select priority</div>
                        </div>
                        <div class="form-field">
                            <div class="lable">Due date</div>
                            <input type="date" class="title-field" autocomplete="off" formControlName="taskDueAt">
                        </div>
                        <div class="form-field assignee-field">
                            <div class="lable">Assignees</div>
                            <mat-form-field appearance="fill" class="topic-select">
                                <mat-select placeholder="Select Assignees" #assigneeSelect formControlName="taskAssigneeIds" multiple
                                    panelClass="create-task-select-panel">
                                    <mat-select-trigger>
                                        <span class="assignee-select-summary" *ngIf="selectedSuggestAssignees().length === 1">
                                            {{selectedSuggestAssignees()[0] | memberFullName}}
                                        </span>
                                        <span class="assignee-select-summary" *ngIf="selectedSuggestAssignees().length > 1">
                                            {{selectedSuggestAssignees().length}} assignees
                                        </span>
                                    </mat-select-trigger>
                                    <mat-option class="topic-item suggest" *ngFor="let person of assigneeList"
                                        [value]="person.id">{{person | memberFullName}}</mat-option>
                                </mat-select>
                                <img class="arrow-down" [ngClass]="{ 'open': assigneeSelect.panelOpen}"
                                    src="../../assets/images/arrow-down.svg" matSuffix alt="">
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="form-section create-attachments-section">
                    <div class="documents-header">
                        <div class="section-heading">
                            <span>Attachments</span>
                            <span class="section-count" *ngIf="selectedSuggestFiles.length">{{selectedSuggestFiles.length}}</span>
                        </div>
                    </div>
                    <div class="document-list" *ngIf="selectedSuggestFiles.length">
                        <div class="document-row" *ngFor="let file of selectedSuggestFiles; index as i">
                            <mat-icon>description</mat-icon>
                            <div class="document-main">
                                <span>{{file.name}}</span>
                                <span class="document-meta">{{formatBytes(file.size)}}</span>
                            </div>
                            <button type="button" class="document-remove" aria-label="Remove attachment" (click)="removeSuggestFile(i)">
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>
                    </div>
                    <label class="create-attach-file"
                        [attr.for]="isDialogMode ? 'task-create-attachments-input-dialog' : 'task-create-attachments-input-drawer'"
                        (dragover)="$event.preventDefault()" (drop)="onSuggestFilesDropped($event)">
                        <mat-icon>attach_file</mat-icon>
                        <strong>Drag &amp; drop files here or click to browse</strong>
                        <span>PDF, PNG, JPG, DOCX up to 10MB</span>
                        <input [id]="isDialogMode ? 'task-create-attachments-input-dialog' : 'task-create-attachments-input-drawer'"
                            type="file" multiple
                            accept="image/*,.pdf,.docx" (change)="onSuggestFilesSelected($event)">
                    </label>
                </div>
                <div class="form-section notification-section">
                    <div class="form-section-title">Notification</div>
                    <div class="notification-options">
                        <label class="notification-toggle">
                            <span>In-app notification</span>
                            <input type="checkbox" class="notification-switch" formControlName="taskNotifyInApp"
                                aria-label="In-app notification">
                        </label>
                        <label class="notification-toggle">
                            <span>Email notification</span>
                            <input type="checkbox" class="notification-switch" formControlName="taskNotifyEmail"
                                aria-label="Email notification">
                        </label>
                    </div>
                </div>
                <div class="cta portal-detail-sticky-actions">
                    <button class="cancel" type="button" (click)="closeCreateDialog()">Cancel</button>
                    <button class="submit" type="submit" [disabled]="submitted">
                        {{ submitted ? 'Creating…' : 'Create task' }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</ng-template>
<ng-template #noDescription>
    <div class="description-box empty">No description provided.</div>
</ng-template>

<ng-template #documentsBlock>
    <app-portal-detail-section
        title="Attachments"
        sectionClass="documents-section"
        [open]="isSectionOpen('attachments')"
        (toggle)="toggleSection('attachments')">
        <span portalDetailSectionMeta class="section-header-meta count-meta">
            <mat-icon>attach_file</mat-icon>
            <span>{{attachmentsCount()}}</span>
        </span>
            <div class="document-upload-row" *ngIf="selectedDocumentFiles.length">
                <mat-icon class="document-upload-icon" aria-hidden="true">description</mat-icon>
                <span class="document-selection">{{selectedDocumentLabel()}}</span>
                <button type="button" class="upload-action" (click)="uploadDocuments()"
                    [disabled]="isUploadingDocuments">
                    {{isUploadingDocuments ? 'Uploading...' : 'Upload'}}
                </button>
            </div>
            <div class="document-list" *ngIf="taskDetail?.documents?.length; else noDocuments">
                <div class="document-row" *ngFor="let document of taskDetail?.documents; trackBy: trackByDocumentId">
                    <mat-icon class="document-type-icon">description</mat-icon>
                    <div class="document-main">
                        <a *ngIf="document.currentVersion?.downloadUrl; else documentTitle"
                            [href]="document.currentVersion?.downloadUrl" target="_blank"
                            rel="noopener noreferrer" class="sub-task-link"
                            [attr.title]="documentName(document)"
                            [attr.aria-label]="'Download ' + documentName(document)">
                            <span class="document-title">{{documentName(document)}}</span>
                            <mat-icon class="document-download-icon" aria-hidden="true">download</mat-icon>
                        </a>
                        <ng-template #documentTitle><span>{{documentName(document)}}</span></ng-template>
                        <span class="document-meta" *ngIf="documentMeta(document)">
                            {{documentMeta(document)}}
                        </span>
                    </div>
                    <button type="button" class="document-remove"
                        [attr.aria-label]="'Remove ' + documentName(document)"
                        (click)="removeDocument(document)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>
            </div>
            <ng-template #noDocuments>
                <div class="empty-documents">No attachments yet.</div>
            </ng-template>
            <label class="detail-attach-file"
                [attr.for]="isDialogMode ? 'task-detail-attachments-input-dialog' : 'task-detail-attachments-input-drawer'">
                <mat-icon aria-hidden="true">attach_file</mat-icon>
                <strong>Attach file</strong>
                <span>PDF, PNG, JPG, DOCX up to 10MB</span>
                <input [id]="isDialogMode ? 'task-detail-attachments-input-dialog' : 'task-detail-attachments-input-drawer'"
                    type="file" multiple
                    accept="image/*,.pdf,.docx" (change)="onDocumentFilesSelected($event)">
            </label>
    </app-portal-detail-section>
</ng-template>

<ng-template #subtaskLoader>
    <div *ngFor="let number of [0, 1, 2, 3, 4]">
        <ngx-skeleton-loader count="1" appearance="line" [theme]="{
                      width: '100%',
                      height: '45px'
                    }"></ngx-skeleton-loader>
    </div>
</ng-template>
